import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from 'jsx/elements/messages/Tooltip';
import { usePortfolioTranslation as useLocale } from 'jsx/hooks/useTranslation';

import useIncrement from 'hooks/useIncrement';
import MoreItemsArrow from 'jsx/elements/buttons/MoreItemsArrow';
import PortfolioTableRow from './PortfolioTableRow';

const PortfolioTable = ({ customers }) => {
  const [count, increment] = useIncrement(customers.length, 20, 20);
  return (
    <div className="table-wrap text-left">
      <Tooltip id="titles" />
      <Tooltip id="credit" />
      <Tooltip id="isMonitored" />
      <Tooltip id="isRegisteredDD" />
      <Tooltip id="covidDescription" />
      <table className="table advanced zebra gutter-bottom">
        <colgroup>
          <col width="5%" />
          <col width="25%" />
          <col width="10%" />
          <col width="15%" />
          <col width="18%" />
          <col width="15%" />
          <col width="15%" />
        </colgroup>
        <thead className="no-border allow-wrap">
          <PortfolioTableHeader>
            <PortfolioTableHeaderItem />
            <PortfolioTableHeaderItem title="customer" />
            <PortfolioTableHeaderItem title="creditRating" position="center" />
            <PortfolioTableHeaderItem title="covid" />
            <PortfolioTableHeaderItem title="paymentBehavior6m" tip />
            <PortfolioTableHeaderItem title="outstandingCount" tip />
            <PortfolioTableHeaderItem title="pbhOutstandingWithDue" position="right" tip />
          </PortfolioTableHeader>
        </thead>
        <tbody className="only-bottom-border">
          {customers.slice(0, count).map((c) => (
            <PortfolioTableRow customer={c} key={c.subjectRegno} />
          ))}
          {customers.length === 0 && <NoDataRow />}
        </tbody>
      </table>
      {count < customers.length && <MoreItemsArrow onClick={increment} />}
    </div>
  );
};

PortfolioTable.propTypes = {
  customers: PropTypes.array.isRequired,
};

PortfolioTable.defaultProps = {
  customers: [],
};

const NoDataRow = () => {
  const { t } = useLocale();
  return (
    <tr>
      <td colSpan="7" className="text-center text-semibold" style={{ padding: '20px 0' }}>
        {t('portfolio_table_noRecords')}
      </td>
    </tr>
  );
};

const PortfolioTableHeaderItem = ({ tip = false, title, position = 'left' }) => {
  const { t } = useLocale();
  return (
    <th className={'text-' + position}>
      {title && (
        <span data-for={tip && 'titles'} data-tip={tip && t(`portfolio_table_header_${title}_tip`)}>
          {t(`portfolio_table_header_${title}`)}
        </span>
      )}
    </th>
  );
};

const PortfolioTableHeader = ({ children }) => <tr>{children}</tr>;

export default PortfolioTable;
